export const config = {
  // Production
  BASE_URL: 'https://api.qrbuddy.ai',
  WEB_URL: 'https://app.qrbuddy.ai',
  BACKEND_ATTACHMENT_URL: 'https://assets.qrbuddy.ai',

  // Staging
  // BASE_URL: 'https://dev-api.qrbuddy.ai',
  // WEB_URL: 'https://app.qrbuddy.ai',
  // BACKEND_ATTACHMENT_URL: 'https://assets.qrbuddy.ai',

  // local
  // BASE_URL: 'http://192.168.0.108:3030',
  // WEB_URL: 'http://localhost:3000',
  // BACKEND_ATTACHMENT_URL: 'https://localhost:8642',

  SECRET_KEY: 'G9vKx2LmTqZ',

  AUTH_KEY: 'authkey',
  BEARER_TOKEN: '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',

  DEALER_SETUP_FEE_ID: 'dac058a5-16b3-4b8e-b9e8-88754bd88af8',

  AUTO_ASSISTANT_CONTACT_NUMBER: '216-400-5617',
  REFERRAL_CODE_PARAM_KEY: 'refCode',
  AFFILIATE_GROUP_PARAM_KEY: 'groupCode',
  SETUP_FEE: 995,
  PRELOADED_WALLET_CREDITS: 1000,

  HOME_PAGE_INTRO_VIDEO: 'https://assets.qrbuddy.ai/web/QRBuddy-Promo.mp4',
};

/// API endpoints
export const ApiEndpoint = {
  REQUEST_DEMO: '/request-demo',
  SALES_REP_LIST: '/sales-rep-list',
};

export const AppColors = {
  liteRedColor: '#FFCCD1',
  redColor: '#FF4155',
  whiteColor: '#FFFFFF',
  backgroundColor: '#FAFAFA',
  primaryColor: '#007CB4',
  blackColor: '#303336',
  grayZeroColor: '#EEF1F7',
  grayOneColor: '#AEB2B7',
  grayTwoColor: '#93989F',
  grayThreeColor: '#6B727A', // '#60656C',
  litePrimaryColor: '#E5F2FF',
  strokeColor: '#E8ECF4',
  yellowColor: '#FEC703',
  orangeColor: '#F7922C',
  secondaryColor: '#00B0E5',
  greenColor: '#00DB7D',
  tableHeader: '#007cb41f',
  lightYellowColor: '#FFDE59',
  lightYellowColor2: '#E8F13A',
  purpleColor: '#a259ff',

  blueColor: '#009ee1',
  menuColor: '#7c7cfc',
  textBlackColor: '#333333',
  subTitleColor: '#6453FE',
  blueTextColor: '#3a31b1',
  blueTextColor2: '#3C5496',
  darkBlueTextColor: '#0F316B',
  buttonTextColor: '#778ef7',
  vividAzureColor: '#5ab9f9',
  azureColor: '#239fce',
  violetColor: '#5e17eb',
  vividBlueColor: '#0866ff',
  vividBlueColor2: '#0069ef',
  darkGrayColor: '#424242',
  darkGrayColor2: '#545454',
  darkGrayColor3: '#49484d',
  vividIndigoColor: '#8669fa',
  lightBlueColor: '#f4f5f7',
  lightBlueTransparentColor: '#f4f5f773',
  vividTurquoiseColor: '#5de0e6',
  soulStoneBlueColor: '#004aad',
  pastelIndigoColor: '#9778fe',
  pastelAzureColor: '#67b3fe',
  greenColor2: '#39b54a',
  greenStrokeColor: '#00bf63',
  grayColor: '#737373',
  grayColor2: '#555555',
  orangeBGColor: '#f9a048',
  autoShowTextColor: '#0F224D',
  autoShowGreenColor: '#3E6E48',
  autoShowFooterTextColor: '#4e505a',

  textGradient: 'linear-gradient(to right, #9D61FF, #38C7FF)',
  aiGradient: 'linear-gradient(to right, #38C7FF, #9D61FF)',
  aiGradient2: 'linear-gradient(to right, #43D7FF, #9D70FE)',
  aiGradient3: 'linear-gradient(to right, #437fe7, #4633bb)',
  aiGradient4: 'linear-gradient(to right, #4571ce, #583ebd)',
  aiGradient5: 'linear-gradient(to right, #004aad, #e385ec)',
  aiGradient6: 'linear-gradient(to right, #5de0e6, #004aad)',
  aiGradient7: 'linear-gradient(to right, #8c52ff, #5ce1e6)',
  aiGradient8: 'linear-gradient(to bottom, #ffffff, #B1CAFF)',
  aiGradient9: 'linear-gradient(to right, #004aad, #cb6ce6)',
  aiGradientTransparent:
    'linear-gradient(to right, rgba(157, 97, 255, 0.12), rgba(56, 199, 255, 0.12))',
  aiGradientCrossTransparent:
    'linear-gradient(to bottom right, rgba(157, 97, 255, 0.12), rgba(56, 199, 255, 0.12))',
  aiGradientTransparent2:
    'linear-gradient(to right, rgba(56, 199, 255, 0.16), rgba(157, 97, 255, 0.16))',
  aiGradientTransparent3:
    'linear-gradient(to right, rgba(56, 199, 255, 0.80), rgba(157, 97, 255, 0.80))',
  aiGradientTransparent4:
    'linear-gradient(to right, rgba(140, 82, 255, 0.93), rgba(92, 225, 230, 0.93))',
  aiGradientCross: 'linear-gradient(to bottom right, #9D61FF, #38C7FF)',
  // headerGradient: 'linear-gradient(to right, #f6efff80, #d3feff80, #d1ffff80)',
  headerGradient: 'linear-gradient(to right, #fff7ff, #f0ffff, #f0ffff)',
  // homePageFeatureGradient: 'linear-gradient(to right, #4ED9FF, #9F67FC)',
  // aiHeaderGradient: 'linear-gradient(to right left, #d1ffff40, #d3feff40, #f6efff40)',

  whiteTransparent: 'rgba(255, 255, 255, 0.12)',

  blueGradient: 'linear-gradient(to bottom, #274D7E, #1C3861)',
  bannerGradient: 'linear-gradient(to bottom, #111F49, #1D2F69, #3851A8, #656DC0, #CACEF0)',
};

export const typographyClamps = {
  // Headings
  h1: 'clamp(2.5rem, 1.5rem + 5vw, 6rem)', // 40px → 96px
  h2: 'clamp(2rem, 1.2rem + 3vw, 3.75rem)', // 32px → 60px
  h3: 'clamp(1.75rem, 1rem + 2.5vw, 3rem)', // 28px → 48px
  h4: 'clamp(1.5rem, 0.9rem + 2vw, 2.125rem)', // 24px → 34px
  h5: 'clamp(1.25rem, 0.8rem + 1.5vw, 1.5rem)', // 20px → 24px
  h6: 'clamp(1rem, 0.7rem + 1vw, 1.25rem)', // 16px → 20px

  // Body text
  body1: 'clamp(0.9rem, 0.8rem + 0.4vw, 1rem)', // 14.5px → 16px
  body2: 'clamp(0.75rem, 0.7rem + 0.3vw, 0.9rem)', // 12px → 14.5px

  // Subtitles
  subtitle1: 'clamp(1rem, 0.85rem + 0.4vw, 1.125rem)', // 16px → 18px
  subtitle2: 'clamp(0.875rem, 0.8rem + 0.3vw, 1rem)', // 14px → 16px

  // Small text
  caption: 'clamp(0.7rem, 0.65rem + 0.3vw, 0.8rem)', // 11px → 12.8px
  overline: 'clamp(0.7rem, 0.65rem + 0.2vw, 0.75rem)', // 11px → 12px
  button: 'clamp(0.8rem, 0.7rem + 0.3vw, 0.875rem)', // 13px → 14px

  fontSize10: 'clamp(0.625rem, 1.2vw, 0.75rem)', // 10px
  fontSize11: 'clamp(0.688rem, 1.3vw, 0.8125rem)', // 11px
  fontSize12: 'clamp(0.75rem, 1.4vw, 0.875rem)', // 12px
  fontSize13: 'clamp(0.813rem, 1.5vw, 0.9375rem)', // 13px
  fontSize14: 'clamp(0.875rem, 1.6vw, 1rem)', // 14px
  fontSize15: 'clamp(0.938rem, 1.7vw, 1.0625rem)', // 15px
  fontSize16: 'clamp(1rem, 1.8vw, 1.125rem)', // 16px
  fontSize17: 'clamp(1.063rem, 2vw, 1.25rem)', // 17px
  fontSize18: 'clamp(0.875rem, 2vw, 1.5rem)', // 18px
  fontSize20: 'clamp(1rem, 2.2vw, 1.75rem)', // 20px
  fontSize22: 'clamp(1.0625rem, 2.5vw, 1.875rem)', // 22px
  fontSize24: 'clamp(1.125rem, 3vw, 2.125rem)', // 24px
};
